import isEmptyObject from '../isEmptyObject';
/**
 * Creates a query string for use in URLs from an object. Automatically URL
 * encodes each value for you. Will order the url params alphabetically by key
 * to ensure stable query string construction.
 *
 * @param  {Object} params The url parameters to create the query string from
 * @return {String} The URL encoded query string
 * @throws {Error} If a param isn't a number or string with length > 0
 *
 * @public
 * @author Alex Kasemir and Connor Taylor
 * @example
 *
 * const params = constructQueryString({
 *   foo: `bar `,
 *   bar: `baz`,
 * });
 *
 * // ?bar=baz&foo=bar%20
 */

var constructQueryString = function constructQueryString(params) {
  if (isEmptyObject(params)) {
    return "";
  } // Sort the keys to prevent ordering issues


  var paramKeys = Object.keys(params);
  paramKeys.sort();
  var paramString = paramKeys.map(function (key) {
    if (typeof params[key] !== "string" && typeof params[key] !== "number") {
      throw new Error("Cannot construct query param for " + key + ", value isn't a string or number");
    } else if (params[key] === "") {
      throw new Error("Query param " + key + " is the empty string!");
    }

    return key;
  }).map(function (key) {
    return [key, params[key]].map(encodeURIComponent).join("=");
  }).join("&");
  return "?" + paramString;
};
/** @component */


export default constructQueryString;